import React from 'react';
import { Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { tokenIsExpired } from '../../../actions/authentication';
import { loading, getRoute } from '../../../actions/sessions';
import Support from '../../shared/Support';
import Loading from '../../shared/Loading';
import UserVerification from '../../shared/UserVerification';

export default function ExistingUser({defaultValue, onSuccessPath}) {
  const publicKey = useSelector(state => state.sessions.get('public_key'));
  const token = useSelector(state => state.authentication.get('token'));
  const isError = useSelector(state => state.sessions.get('errors'));
  const isLoading = useSelector(state => state.sessions.get('loading'));

  if (isError && isError.count() > 0 && !tokenIsExpired(token)) {
    return (<Redirect to="/invalid" />);
  }

  if (!publicKey) {
    return (
      <div id="content" className="has-text-centered">
        <div className="is-size-4 has-text-weight-semibold">You have reached this page in error.</div>
        This site is for processing credit applications and business purchases with Credit Key.
        <Support />
      </div>
    )
  }

  if (isLoading) return <Loading active={true} />

  return (
    <div id="content">
      <div className="columns is-centered">
        <div className="column has-text-centered">
          {tokenIsExpired(token) && <p className="title is-spaced has-text-centered">Your session has expired, please sign in to continue</p>}
          {!tokenIsExpired(token) && <p className="title is-spaced has-text-centered">Please sign in</p>}
          <p className="has-text-centered">
            We'll send a 6 digit code to you.
          </p>
        </div>
      </div>

      <UserVerification
        defaultValue=''
        onSuccessPath='existing_user_token'
        onLoading={loading}
        isLoading={isLoading}
      />
    </div>
  )
}
